/*  Shared  */
import { Features } from 'application/Shared/Constants';
import Helpers from 'application/Shared/Helpers/Functions';
import SessionHelper from 'application/Shared/Helpers/SessionHelper';

import Env from './Env';

/*  Constants  */
const env = new Env();

class Feature {
    constructor(feature) {
        this.feature = feature;
    }

    getStatus() {
        const { feature } = this;
        if (!Helpers.isset(Features, feature)) {
            return 'N/A';
        }

        return Features[feature];
    }

    isBeta() {
        if (this.getStatus() === 'beta') {
            return true;
        }

        return false;
    }

    isDev() {
        if (this.getStatus() === 'dev') {
            return true;
        }

        return false;
    }

    isDemo() {
        if (this.getStatus() === 'demo') {
            return true;
        }

        return false;
    }

    isReleased() {
        if (this.getStatus() === 'released') {
            return true;
        }

        return false;
    }

    isEnabled(session) {
        if (this.isReleased() || env.isDev()) {
            return true;
        }

        // If the feature is DEV only
        if (this.isDev() && env.isDemo()) {
            return false;
        }

        if (this.isDemo() && env.isDemo()) {
            return true;
        }

        if (!this.isBeta()) {
            return false;
        }

        if (!env.isDemo()) {
            return false;
        }

        const sessionHelper = new SessionHelper(session);
        if (sessionHelper.isGlobalAdmin()) {
            return true;
        }

        return false;
    }
}

export default Feature;
